import { render } from "./linkDisease.vue?vue&type=template&id=244e88af"
import script from "./linkDisease.vue?vue&type=script&lang=js"
export * from "./linkDisease.vue?vue&type=script&lang=js"

import exportComponent from "D:\\svn test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__